import { FC, SVGProps } from 'react'

export const CloudUpload: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="36"
    height="36"
    viewBox="0 0 36 36"
    fill="none"
    {...props}
  >
    <path
      d="M23.7872 24.1079L17.9997 18.3203L12.2122 24.1079"
      stroke="currentColor"
      strokeOpacity="0.923"
      strokeWidth="1.62775"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18 18.3203V31.3423"
      stroke="currentColor"
      strokeOpacity="0.923"
      strokeWidth="1.62775"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M30.1397 27.5667C31.5509 26.7974 32.6657 25.58 33.3082 24.1067C33.9507 22.6334 34.0842 20.9881 33.6878 19.4305C33.2913 17.8728 32.3874 16.4916 31.1188 15.5047C29.8501 14.5178 28.2889 13.9815 26.6817 13.9805H24.8586C24.4206 12.2865 23.6044 10.7139 22.4711 9.38083C21.3379 8.04775 19.9172 6.98892 18.3159 6.28394C16.7146 5.57895 14.9743 5.24616 13.2258 5.31058C11.4773 5.375 9.76622 5.83496 8.22111 6.65587C6.676 7.47678 5.33709 8.63729 4.30504 10.0501C3.27299 11.463 2.57466 13.0914 2.26256 14.813C1.95045 16.5346 2.03268 18.3045 2.50308 19.9898C2.97347 21.675 3.81978 23.2317 4.97839 24.5427"
      stroke="currentColor"
      strokeOpacity="0.923"
      strokeWidth="1.62775"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M23.7872 24.1079L17.9997 18.3203L12.2122 24.1079"
      stroke="currentColor"
      strokeOpacity="0.923"
      strokeWidth="1.62775"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
